import types from 'constants/actionTypes';
import { combineReducers } from 'redux';
import mergeByIds from '../../utils/mergeByIds';

const initialState = {
  byId: {},
  selectedTemplateId: null,
  duplicateTemplateId: null,
  swappedTemplateId: null,
};

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_MODEL_TEMPLATES_SPECS_REQUEST_SUCCESS:
      return mergeByIds({
        byIdCurrent: state,
        byIdToMerge: payload.entities.templates,
      });
    case types.GET_TEMPLATE_DETAIL_IMAGES_REQUEST_SUCCESS:
      const { templateId, detailImages } = payload;
      state[templateId] = { ...state[templateId], detailImages };
      return state;
    default:
      return state;
  }
};

const selectedTemplateId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.selectedTemplateId;
  }

  switch (type) {
    case types.SET_SELECTED_TEMPLATE_ID:
      const templateId = payload;
      if (state === templateId) {
        return null;
      } else {
        return templateId;
      }
    default:
      return state;
  }
};

const duplicateTemplateId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.duplicateTemplateId;
  }

  switch (type) {
    case types.SET_DUPLICATE_TEMPLATE_ID:
      const templateId = payload;
      return templateId;
    default:
      return state;
  }
};

const swappedTemplateId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.swappedTemplateId;
  }

  switch (type) {
    case types.SET_SWAPPED_TEMPLATE_ID:
      const templateId = payload;
      return templateId;
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  selectedTemplateId,
  duplicateTemplateId,
  swappedTemplateId,
});
